import { lazy } from 'react';

import { useWidget } from 'state/widget/context';

const AdBlockWidget = lazy(() => import('components/widgets/AdBlockWidget'));

const AdvanceLocalWidget = lazy(
  () => import('components/widgets/AdvanceLocalWidget'),
);

const ArticleStackWidget = lazy(
  () => import('components/widgets/ArticleStackWidget'),
);

const AtlasObscuraWidget = lazy(
  () => import('components/widgets/AtlasObscuraWidget'),
);

const BannerWidget = lazy(() => import('components/widgets/BannerWidget'));

const CarouselWidget = lazy(() => import('components/widgets/CarouselWidget'));

const CBSNewsWidget = lazy(
  () => import('components/widgets/cbs/CBSNewsWidget'),
);

const CBSSurvivorWidget = lazy(
  () => import('components/widgets/cbs/SurvivorWidget'),
);

const CNNRightRailWidget = lazy(
  () => import('components/widgets/cnn/CNNRightRailWidget'),
);

const CNNSinglePlayerWidget = lazy(
  () => import('components/widgets/cnn/CNNSinglePlayerWidget'),
);

const DailyMailWidget = lazy(
  () => import('components/widgets/DailyMailWidget'),
);

const FloatingCarouselWidget = lazy(
  () => import('components/widgets/FloatingCarouselWidget'),
);

const ForcedPlaybackCarouselWidget = lazy(
  () => import('components/widgets/ForcedPlaybackCarouselWidget'),
);

const FrontOfficeSportsWidget = lazy(
  () => import('components/widgets/FrontOfficeSportsWidget'),
);

const IABCarouselWidget = lazy(
  () => import('components/widgets/IABCarouselWidget'),
);

const LandscapeCarouselWidget = lazy(
  () => import('components/widgets/landscapeCarousel/LandscapeCarouselWidget'),
);

const LandscapeAnimatedCarouselWidget = lazy(
  () =>
    import(
      'components/widgets/landscapeCarousel/LandscapeAnimatedCarouselWidget'
    ),
);

const LandscapeCarouselAutoplayWidget = lazy(
  () =>
    import(
      'components/widgets/landscapeCarousel/LandscapeCarouselAutoplayWidget'
    ),
);

const LandscapeInlineCarouselWidget = lazy(
  () =>
    import(
      'components/widgets/landscapeCarousel/LandscapeInlineCarouselWidget'
    ),
);

const ResponsiveSideBySideWidget = lazy(
  () => import('components/widgets/ResponsiveSideBySideWidget'),
);

const MTVWidget = lazy(() => import('components/widgets/cbs/MTVWidget'));

const OneByThreeWidget = lazy(
  () => import('components/widgets/OneByThreeWidget'),
);

const PopSugarWidget = lazy(() => import('components/widgets/PopSugarWidget'));

const SCACarouselWidget = lazy(
  () => import('components/widgets/sca/SCACarouselWidget'),
);

const SCAInlineCarouselWidget = lazy(
  () => import('components/widgets/sca/SCAInlineCarouselWidget'),
);

const SCAThreeByOneWidget = lazy(
  () => import('components/widgets/sca/SCAThreeByOneWidget'),
);

const SimpleThreeByOneWidget = lazy(
  () => import('components/widgets/SimpleThreeByOneWidget'),
);

const TalkhouseWidget = lazy(
  () => import('components/widgets/TalkhouseWidget'),
);

const TextOnlyWidget = lazy(() => import('components/widgets/TextOnlyWidget'));

const ThreeByOneStackedWidget = lazy(
  () => import('components/widgets/ThreeByOneStackedWidget'),
);

const ThreeByOneStackedLandscapeWidget = lazy(
  () => import('components/widgets/ThreeByOneStackedLandscapeWidget'),
);

const ThreeByOneHScrollWidget = lazy(
  () => import('components/widgets/ThreeByOneHScrollWidget'),
);

const ThreeByOneListWidget = lazy(
  () => import('components/widgets/ThreeByOneListWidget'),
);

const WellAndGoodWidget = lazy(
  () => import('components/widgets/WellAndGoodWidget'),
);

const FortuneArticleWidget = lazy(
  () => import('components/widgets/fortune/FortuneArticleWidget'),
);

const FortuneRightRailWidget = lazy(
  () => import('components/widgets/fortune/FortuneRightRailWidget'),
);

const GridExtraTVWidget = lazy(
  () => import('components/widgets/extratv/GridExtraTVWidget'),
);

const StackedExtraTVWidget = lazy(
  () => import('components/widgets/extratv/StackedExtraTVWidget'),
);

const ImageFocusedWidget = lazy(
  () => import('components/widgets/nativo/ImageFocusedWidget'),
);

const CharismaNewsWidget = lazy(
  () => import('components/widgets/CharismaNewsWidget'),
);

const ClickOnlyImageFocusedWidget = lazy(
  () => import('components/widgets/nativo/ClickOnlyImageFocusedWidget'),
);

const TheCoreWidget = lazy(() => import('components/widgets/TheCoreWidget'));

const ResponsiveWidget = lazy(
  () => import('components/widgets/nativo/ResponsiveWidget'),
);

const IndianExpressWidget = lazy(
  () => import('components/widgets/indianExpress/IndianExpressWidget'),
);

const BoomliveDarkWidget = lazy(
  () => import('components/widgets/BoomliveDarkWidget'),
);

const TheQuintWidget = lazy(() => import('components/widgets/TheQuintWidget'));

const EnterpriseNByOneHScrollWidget = lazy(
  () => import('components/widgets/EnterpriseNByOneHScrollWidget'),
);

const BoomliveArticleWidget = lazy(
  () => import('components/widgets/BoomliveArticleWidget'),
);

const NewstatesmanWidget = lazy(
  () => import('components/widgets/NewstatesmanWidget'),
);

const TovimaWidget = lazy(() => import('components/widgets/TovimaWidget'));

const TrueCrimeNewsHomepageWidget = lazy(
  () => import('components/widgets/TrueCrimeNewsHomepageWidget'),
);

const EnterpriseNByOneStackedWidget = lazy(
  () => import('components/widgets/EnterpriseNByOneStackedWidget'),
);

const EdinburghNewsWidget = lazy(
  () => import('components/widgets/EdinburghNewsWidget'),
);

const IndianExpressSingleUnitWidget = lazy(
  () =>
    import('components/widgets/indianExpress/IndianExpressSingleUnitWidget'),
);

const LATimesWidget = lazy(() => import('components/widgets/LATimesWidget'));

export interface WidgetVariantLoaderProps {}

const WidgetVariantLoader: React.FC<WidgetVariantLoaderProps> = () => {
  const {
    state: { variantId },
  } = useWidget();

  switch (variantId) {
    case 'DV_cko4spbf500020uovi0bu245e':
      return <ThreeByOneStackedWidget />;

    case 'DV_ckvii5hsx0000b1qau4ewlvwy':
      return (
        <ThreeByOneStackedWidget
          numberOfUnits={{ horizontal: 3, vertical: 2 }}
        />
      );

    case 'DV_cl01ggvi20000mpogvak63cs6':
      return (
        <ThreeByOneStackedWidget
          numberOfUnits={{ horizontal: 4, vertical: 3 }}
        />
      );

    case 'DV_ckynft65v0000u8qfziuxdqe7':
      return <ThreeByOneStackedLandscapeWidget />;

    case 'DV_cko4sosvd00010uovnm8jz95a':
      return <CarouselWidget />;

    case 'DV_ckykjxrsd0000ytogtbm8exe4':
      return <ForcedPlaybackCarouselWidget />;

    case 'DV_ckr3u0go30000dip199xf5kd5':
      return <ThreeByOneHScrollWidget />;

    case 'DV_ckz30vcue0000fiqde08a5td0':
      return (
        <ThreeByOneHScrollWidget
          artworkAspectRatio={9 / 16}
          artworkResizeStrategy="fit"
          controlsSize="md"
        />
      );

    case 'DV_cl8bxefcb00030uqf30r1idyy':
      return (
        <ThreeByOneHScrollWidget
          artworkAspectRatio={0.666666667}
          artworkResizeStrategy="fill"
          unitSpacing={12}
        />
      );

    case 'DV_ckrdjkgwl00003fp32uv4259g':
      return <ThreeByOneListWidget />;

    case 'DV_ckrqo2kb20000j3p1jq6ee2hp':
      return <IABCarouselWidget />;

    case 'DV_cku46pgry00007gp1r7gun66p':
      return <BannerWidget />;

    case 'DV_cku479vz600017gp1kowo3e9w':
      return <SimpleThreeByOneWidget />;

    case 'DV_ckyepo0kv0000xkqa68bdy5y9':
      return <OneByThreeWidget />;

    case 'DV_ckyot6vk7000084qfdabcw2k2':
      return <PopSugarWidget />;

    case 'DV_ckz4a2t2z0000a8qdrvof5s7i':
      return <CBSNewsWidget />;

    case 'DV_ckz5q1y9y0000w0qdwm5i3szm':
      return <LandscapeCarouselWidget />;

    case 'DV_cl4327bd10000t7qjo5q4glne':
      return <LandscapeAnimatedCarouselWidget />;

    case 'DV_ckzfzqqsq000087qdkuytmtch':
      return <LandscapeInlineCarouselWidget />;

    case 'DV_cl5si3ass00000vp5mhs81n6r':
      return <LandscapeCarouselAutoplayWidget />;

    case 'DV_ckzq01bv00000d8ogv8u92m7v':
      return <FloatingCarouselWidget />;

    case 'DV_cl00061o50000wuog3a446rbv':
      return <SCACarouselWidget />;

    case 'DV_cl0007dk20001wuogrt97wp9h':
      return <SCAThreeByOneWidget />;

    case 'DV_cl3d7hytx00007aq5n03o7cwk':
      return <SCAInlineCarouselWidget />;

    case 'DV_cl1w8nhac00000xrz2nhhgw1j':
      return <ArticleStackWidget podcastNamePrefix="From: " textWrapsPlayer />;

    case 'DV_cl8btkyjs00020uqf8wxg6sr8':
      return <ArticleStackWidget textWrapsPlayer />;

    case 'DV_cl48k178300000zntjhd7l6py':
      return (
        <ArticleStackWidget podcastNamePrefix="From: " playerPosition="left" />
      );

    case 'DV_cl7f6hnrq00000tqy299011s2':
      return <MTVWidget />;

    case 'DV_cl8j7w2px00000smzognlagbs':
      return <ResponsiveSideBySideWidget />;

    case 'DV_cl8all8na00000vqfafq7r919':
      return <FrontOfficeSportsWidget />;

    case 'DV_cl9iqnckn00000qo4qohj1c0h':
      return <AdBlockWidget />;

    case 'DV_cldn7q2lg00010tqfeqgu26bi':
      return <TextOnlyWidget />;

    case 'DV_clf06n29x00000rppqkld4o3k':
      return <AtlasObscuraWidget />;

    case 'DV_clf8oaabe00000stknv59aqc9':
      return <TalkhouseWidget />;

    case 'DV_clieke6zw00000qohai2xtwws':
      return <CNNSinglePlayerWidget />;

    case 'DV_cljehapj400010tl4mi8088lh':
      return <CNNRightRailWidget />;

    case 'DV_cljfwtepw00000ul4vvepw9l7':
      return <CNNRightRailWidget controlsVariant="cornerPlay" />;

    case 'DV_cliudjjtt00000slhryikl4lt':
      return <WellAndGoodWidget />;

    case 'DV_clixcuyif00010qmqrp0vu9ta':
      return <AdvanceLocalWidget />;

    case 'DV_clkwuwkuv00010to0j91ulive':
      return <FortuneArticleWidget />;

    case 'DV_clkwprxhs00000so0ngt0r6sk':
      return <FortuneRightRailWidget />;

    case 'DV_clmtezzg300000qmeob2qoyfv':
      return <CBSSurvivorWidget />;

    case 'DV_cln98pnsz00020slqk4jeo8l6':
      return <CNNSinglePlayerWidget linkUnitDecoration="artwork" />;

    case 'DV_cln98p5i400000rlqz833q0yh':
      return <CNNSinglePlayerWidget linkUnitDecoration="playButton" />;

    case 'DV_cln98olms00010slq593ezro1':
      return <CNNSinglePlayerWidget linkUnitDecoration="headphones" />;

    case 'DV_cln9bny5400000qlqx1chyw74':
      return (
        <CNNSinglePlayerWidget titleOverride="Audio recommended by Headliner" />
      );

    case 'DV_clnkle94300020pnqx39xhp3m':
      return <GridExtraTVWidget />;

    case 'DV_clnkpyfbd00000qnq1rqspcl6':
      return <StackedExtraTVWidget />;

    case 'DV_clp76cbq400000qmsebta4jo5':
    case 'DV_cm37pwj9o00000roh3olnt0g2':
      return <ImageFocusedWidget />;

    case 'DV_cltrl9fp700000rrnpaapi863':
      return <ImageFocusedWidget extendedPlayback />;

    case 'DV_clzu8f4bh00000poqqkh8paef':
      return <ImageFocusedWidget />;

    case 'DV_cmbgs3cky00000pnwkw8fwt59':
      return (
        <ImageFocusedWidget
          hideWaveform
          playButtonLabel="play"
          linkText="start watching"
        />
      );

    case 'DV_clpaai8tn00010pms2autt52a':
      return <CharismaNewsWidget />;

    case 'DV_clt4v4idy00000poeagsc9ir9':
      return <ClickOnlyImageFocusedWidget ctaVariant="icon" />;

    case 'DV_clu8nypqt00000rmpkh30uo6f':
      return <TheCoreWidget customDivider />;

    case 'DV_clusue0at00000rrw6kt9sppn':
      return <ResponsiveWidget />;

    case 'DV_clvwkcwpk00020rpc5o0qvegy':
      return <IndianExpressWidget />;

    case 'DV_clvuzr9y200010rpcpbubqm28':
      return <TheCoreWidget hideDescription />;

    case 'DV_clvv43qh000040qpcdxkzbwta':
      return <BoomliveDarkWidget />;

    case 'DV_clwi68jzj00000ss7bz5cb6hr':
      return <TheQuintWidget />;

    case 'DV_clyzyu6g600000prvwnbekrfr':
      return <EnterpriseNByOneHScrollWidget />;

    case 'DV_clz8j8g4500000rnoo4qwh49d':
      return <BoomliveArticleWidget />;

    case 'DV_cm2dduzev00000qph4xtb4uxb':
      return <NewstatesmanWidget />;

    case 'DV_cm2w8fzq300020qoh1a8arxdz':
      return <TovimaWidget />;
    case 'DV_cm2xnmqi200030qohn6lc91mh':
      return <TrueCrimeNewsHomepageWidget />;

    case 'DV_cm2un0jjs00000qoh21w8ud5r':
      return <EnterpriseNByOneStackedWidget />;

    case 'DV_cm3ehsajs00030pohkjge5i8z':
      return <EnterpriseNByOneHScrollWidget fadeColor="#FFFFFF00" />;

    case 'DV_cm4a3ygl000000qprxsbynidb':
      return <EdinburghNewsWidget />;

    case 'DV_cm74tf9wj00000pjx4pi6wmkc':
      return <IndianExpressSingleUnitWidget />;

    case 'DV_cm86b1wpl00000po0lu05h72b':
      return <LATimesWidget />;

    case 'DV_cmcmbp7od00010spb3rg409to':
      return <DailyMailWidget />;

    default:
      throw new Error(`Unhandled widget variant ${variantId}`);
  }
};

export default WidgetVariantLoader;
